import { Download, FileText } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import "../admin-affiliate-premium.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function downloadCsv(path, filename) {
  const token = localStorage.getItem("ss_token");
  fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${token}` } })
    .then(async (r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success("Downloaded");
    })
    .catch((e) => toast.error(`Failed: ${e.message}`));
}

function Card({ title, subtitle, icon: Icon, onDownload, options }) {
  return (
    <div className="ap-glass" style={{ padding: 18 }}>
      <div className="flex items-center gap-3 mb-3">
        <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: "rgba(212,175,55,0.12)", border: "1px solid rgba(212,175,55,0.45)" }}><Icon size={20} className="text-amber-300" /></div>
        <div>
          <div className="font-black text-white text-lg">{title}</div>
          <div className="text-white/55 text-[12.5px]">{subtitle}</div>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map((o) => (
          <button key={o.label} onClick={() => onDownload(o)} className="ap-btn-gold inline-flex items-center gap-2 px-3 h-9 rounded-lg text-[11.5px] font-bold" data-testid={`download-${title.toLowerCase().replace(/\s+/g, '-')}-${o.label}`}>
            <Download size={12} /> {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function AffiliateReports() {
  return (
    <div className="ap-bg p-4 lg:p-6">
      <div className="flex items-end justify-between mb-5">
        <div>
          <div className="text-[10px] uppercase tracking-[0.32em] text-amber-300 font-bold mb-1">EXPORTS</div>
          <div className="text-3xl font-black ap-gold-text">Reports & Export</div>
          <div className="text-white/55 text-sm mt-1">Download CSV reports for accounting, BI, and analysis.</div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Card title="Payouts Report" subtitle="All affiliate payouts with status & tx_ref." icon={FileText}
          options={[
            { label: "7 days", path: "/admin/aff-reports/payouts.csv?days=7", fn: "payouts_7d.csv" },
            { label: "30 days", path: "/admin/aff-reports/payouts.csv?days=30", fn: "payouts_30d.csv" },
            { label: "90 days", path: "/admin/aff-reports/payouts.csv?days=90", fn: "payouts_90d.csv" },
            { label: "Paid only", path: "/admin/aff-reports/payouts.csv?days=365&status=paid", fn: "payouts_paid.csv" },
          ]}
          onDownload={(o) => downloadCsv(o.path, o.fn)} />
        <Card title="Commissions Report" subtitle="Period-by-period commissions ledger." icon={FileText}
          options={[
            { label: "30 days", path: "/admin/aff-reports/commissions.csv?days=30", fn: "commissions_30d.csv" },
            { label: "90 days", path: "/admin/aff-reports/commissions.csv?days=90", fn: "commissions_90d.csv" },
            { label: "1 year", path: "/admin/aff-reports/commissions.csv?days=365", fn: "commissions_1y.csv" },
          ]}
          onDownload={(o) => downloadCsv(o.path, o.fn)} />
        <Card title="Accounts Report" subtitle="All affiliate panel accounts roster." icon={FileText}
          options={[{ label: "All accounts", path: "/admin/aff-reports/accounts.csv", fn: "affiliate_accounts.csv" }]}
          onDownload={(o) => downloadCsv(o.path, o.fn)} />
      </div>
    </div>
  );
}
